import React from "react";

function Perfil(){
    return (
        <div>Perfil</div>
    )
}

export default Perfil